<template>
    <v-layout class="tutorial-wrap" justify-center align-center fill-height>
        <div class="tutorial">
            <v-layout class="items">
                <div class="item"
                     v-for="(image, i) in images"
                     :key="i"
                >
                    <img :src="image.url" />
                    <img v-if="i < images.length - 1" class="btn-tutorial" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_tutorial_next.png" @click="next(i)" />
                    <img v-else class="btn-tutorial" src="https://tpc-general.s3.ap-northeast-2.amazonaws.com/onlyonelife/images/btn_tutorial_start.png" @click="start" />
                </div>
            </v-layout>
        </div>
    </v-layout>
</template>

<script>
    export default {

        mounted() {
            setTimeout(_ => {
                $('.tutorial').fadeIn('slow')
                $('.item:gt(0)').css('opacity', 0)

                this.$playAudio(19)
            })
        },

        computed: {
            images() {
                return this.$gameData.images.tutorial
            }
        },

        methods: {
            next(i) {
                this.$playAudio(1)
                $('.items').animate({
                    marginLeft: -(i + 1) * 945
                }, 300)
                $('.item').eq(i).animate({
                    opacity: 0
                }, 300)
                $('.item').eq(i + 1).animate({
                    opacity: 1
                }, 1000)
            },
            start() {
                this.$playAudio(1)
                $('.tutorial-wrap').fadeOut('slow', _ => {
                    this.$router.push('/game')
                })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .tutorial-wrap {
        .tutorial {
            width: 945px;
            height: 590px;
            overflow: hidden;
            position: relative;
            display: none;

            .items {
                .item {
                    width: 945px;
                    height: 590px;
                    display: inline-block;
                    position: relative;

                    .tutorial-lights {
                        position: absolute;
                        left: 8px; right: 8px;
                        top: 166px; bottom: 112px;
                    }

                    .btn-tutorial {
                        position: absolute;
                        right: 25.7px;
                        bottom: 25px;
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
